angular.module('rjmNg.services').factory 'emailNotificationService', [
  "$http"
  "$url"
  "app"
  ($http, $url, app) ->

    post : (typeId) ->

      # This format mimics the default format used by the jquery.$ajax function
      # which is how most of our old endpoints are setup to use
      $http
        method: 'POST'
        url: $url("/emailnotification")
        data: $.param @_getRequestObject(typeId)
        headers:
          "Content-Type": 'application/x-www-form-urlencoded'
          charset: 'UTF-8'

    _getRequestObject : (typeId) ->
      data =
        clientId: app.getClientId()
        type: typeId
      if app.isSupportUserSession()
        data.adminId = app.getSupportUserId()
      else
        data.userId = app.getUserId()
      return data
]

